import { createStore, get, set, del } from "idb-keyval";

const store = createStore("lf-music", "kv");
export const AUDIO = /\.(mp3|m4a|aac|flac|wav|ogg|oga|opus|webm)$/i;
const MAX_FILES = 10000;

export const kv = { get: (k) => get(k, store), set: (k, v) => set(k, v, store), del: (k) => del(k, store) };
export const canRemember = typeof window !== "undefined" && "showDirectoryPicker" in window;

const parse = (path) => {
  const parts = path.split("/");
  if (parts.length > 1) parts.shift();
  const base = parts[parts.length - 1].replace(AUDIO, "").replace(/^\d{1,3}[\s._-]+/, "");
  const [a, t] = base.includes(" - ") ? base.split(/ - (.+)/) : [null, base];
  return { id: path, path, title: (t || base).trim(), artist: (a || parts[parts.length - 3] || parts[parts.length - 2] || "").trim(), album: parts.length > 2 ? parts[parts.length - 2] : "" };
};

export const scanHandle = async (dir) => {
  const out = [];
  const walk = async (h, prefix, depth) => {
    for await (const entry of h.values()) {
      if (out.length >= MAX_FILES) return;
      const path = prefix ? `${prefix}/${entry.name}` : entry.name;
      if (entry.kind === "file" && AUDIO.test(entry.name)) out.push(parse(path));
      else if (entry.kind === "directory" && depth < 6 && !entry.name.startsWith(".")) await walk(entry, path, depth + 1);
    }
  };
  await walk(dir, dir.name, 0);
  return out.sort((a, b) => a.path.localeCompare(b.path));
};

export const scanFiles = (files) => {
  const map = new Map();
  [...files].filter((f) => AUDIO.test(f.name)).slice(0, MAX_FILES).forEach((f) => {
    const path = f.webkitRelativePath || f.name;
    map.set(path, f);
  });
  return { map, tracks: [...map.keys()].sort().map(parse) };
};

export const fileHandleFor = async (dir, path) => {
  const parts = path.split("/").slice(1);
  let h = dir;
  for (const p of parts.slice(0, -1)) h = await h.getDirectoryHandle(p);
  return h.getFileHandle(parts[parts.length - 1]);
};

export const fileFromHandle = async (dir, path) => (await fileHandleFor(dir, path)).getFile();

export const shuffled = (n, first) => {
  const a = [...Array(n).keys()].filter((i) => i !== first);
  for (let i = a.length - 1; i > 0; i -= 1) { const j = Math.floor(Math.random() * (i + 1)); [a[i], a[j]] = [a[j], a[i]]; }
  return first == null ? a : [first, ...a];
};

const FOLDER_ART = ["cover.jpg", "folder.jpg", "front.jpg", "album.jpg", "cover.png", "folder.png", "front.png"];

export const folderArt = async (dir, path) => {
  const parts = path.split("/").slice(1, -1);
  let h = dir;
  for (const p of parts) h = await h.getDirectoryHandle(p);
  for await (const e of h.values()) {
    if (e.kind === "file" && FOLDER_ART.includes(e.name.toLowerCase())) return e.getFile();
  }
  return null;
};
